/**
 * Internal route chrome.
 *
 * Explains routing behavior, guards, and response semantics.
 */
import type { ReactNode } from 'react'
import { useCart } from '../../cart'
import type { RuntimeHomeSettings } from '../runtimeSettings'
import HomeFallbackFooter from './HomeFallbackFooter'
import { HomeFallbackHeader } from './home-fallback/HomeFallbackHeader'

type Props = {
  children: ReactNode
  homeSettings: RuntimeHomeSettings
  isAdmin: boolean
  shouldRenderRuntimeFooter: boolean
}

const InternalRouteChrome = ({
  children,
  homeSettings,
  isAdmin,
  shouldRenderRuntimeFooter,
}: Props) => {
  const { itemCount } = useCart()

  return (
    <div className="shop-runtime-stage flex min-h-screen flex-col">
      <div className="shop-layout pb-4 pt-5">
        <HomeFallbackHeader homeSettings={homeSettings} isAdmin={isAdmin} itemCount={itemCount} />
      </div>

      <main className="flex-1">{children}</main>

      {shouldRenderRuntimeFooter ? <HomeFallbackFooter homeSettings={homeSettings} /> : null}
    </div>
  )
}

export default InternalRouteChrome
